import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodevalue',
  standalone: true,
})
export class DecodeValuePipe implements PipeTransform {
  transform(value: unknown): string {
    if (!value) {
      return '';
    }

    return this.decodeValue(String(value));
  }

  private decodeValue(value: string): string {
    let decoded = value;

    // Count how many encoded sequences exist
    const maxDecodePasses = this.estimateMaxPasses(value);

    for (let pass = 0; pass < maxDecodePasses; pass++) {
      const normalizedValue = this.normalizeMalformedPercents(decoded);
      const next = this.safeDecode(normalizedValue);

      if (next === decoded) {
        break;
      }

      decoded = next;

      if (!this.hasEncodedSequence(decoded)) {
        break;
      }
    }

    return decoded;
  }

  private estimateMaxPasses(value: string): number {
    const matches = value.match(/%[0-9A-Fa-f]{2}/g);
    return matches ? matches.length : 1;
  }

  private safeDecode(value: string): string {
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }

  private normalizeMalformedPercents(value: string): string {
    let normalized = '';

    for (let index = 0; index < value.length; index++) {
      const char = value[index];
      if (char !== '%') {
        normalized += char;
        continue;
      }

      const hex1 = value[index + 1];
      const hex2 = value[index + 2];
      const hasValidHexPair = this.isHexChar(hex1) && this.isHexChar(hex2);

      if (hasValidHexPair) {
        normalized += `%${hex1}${hex2}`;
        index += 2;
      } else {
        // Encode malformed percent signs so decodeURIComponent preserves them as literal '%'.
        normalized += '%25';
      }
    }

    return normalized;
  }

  private isHexChar(char: string | undefined): boolean {
    return !!char && /^[0-9A-Fa-f]$/.test(char);
  }

  private hasEncodedSequence(value: string): boolean {
    return /%[0-9A-Fa-f]{2}/.test(value);
  }
}
